// extracted by mini-css-extract-plugin
export default {"container":"TitleWithSplit_container__QfHUV","splitter":"TitleWithSplit_splitter__HUa3p","title":"TitleWithSplit_title__DdLub"};